import { FC, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { KendoLoading } from '../../../../components';
import LocationTree from '../../../../components/custom/LocationTree';
import { LocationContext } from '../../../../components/LocationContext';

const LocationsPageLocationTree: FC = () => {
    const { organizationInformationId } = useParams<'organizationInformationId'>();

    const { state, getLocations, getSelectedLocation } = useContext(LocationContext);

    useEffect(() => {
        getLocations(parseInt(organizationInformationId.toString()));
    }, []);

    const handleSelect = async (locationId: string | undefined) => {
        locationId && getSelectedLocation(parseInt(locationId));
    };

    return (
        <>
            {!state.locations && <KendoLoading />}
            {state.locations && <LocationTree onLoadSelectedId={state.selectedLocation?.id} locations={state.locations} onSelect={handleSelect} />}
        </>
    );
};

export default LocationsPageLocationTree;
